<template>
  <fragment>
    <div class="container">
      <div v-if="Array.isArray(integration.screens) && integration.screens.length > 0" class="card mt-4">
        <div class="card-body pb-0">
          <h2 class="mb-3">Screens</h2>
        </div>
        <c-data-list :items="integration.screens" @load="load" class="list-data no-links">
          <template #columns>
            <div class="col-sm-4">Screen Name</div>
            <div class="col-sm-4">Media Owner</div>
            <div class="col-sm-2">Panel ID</div>
            <div class="col-sm-1"></div>
          </template>

          <template #default="{ item }">
            <integration-screens-list-item :screen="item" @removeScreen="handleRemoveScreen" />
          </template>
        </c-data-list>
      </div>

      <div class="card mt-4">
        <div class="card-body pb-0">
          <h2 class="mb-3">Add Screens</h2>
          <screens-list-search v-model="params" />
        </div>
        <c-data-list :items="screens" @load="load" class="list-data no-links">
          <template #columns>
            <div class="col-sm-4">Screen Name</div>
            <div class="col-sm-4">Media Owner</div>
            <div class="col-sm-2">Panel ID</div>
            <div class="col-sm-1"></div>
          </template>

          <template #default="{ item }">
            <screens-list-item :screen="item" @addScreen="handleAddScreen" />
          </template>
        </c-data-list>
      </div>
    </div>
  </fragment>
</template>

<script>
import { helperComputed, helperMethods } from '@/vuex/modules/integrations/screens'
import { compareQueryParams } from '@codium/codium-vue'
import IntegrationScreensListItem from './screens/IntegrationScreensListItem'
import ScreensListItem from './screens/ScreensListItem'
import ScreensListSearch from './screens/ScreensListSearch'

import { get, call } from 'vuex-pathify'

export default {
  components: {
    IntegrationScreensListItem,
    ScreensListSearch,
    ScreensListItem
  },

  data () {
    return {
      params: null
    }
  },

  watch: {
    params: compareQueryParams(async function (params) {
      await this.getScreens({ params, fresh: true })
    })
  },

  computed: {
    ...helperComputed,
    ...get('settings/integrations', ['integration']),
  },

  beforeDestroy () {
    this.resetScreens()
  },

  methods: {
    ...helperMethods,
    ...call('settings/integrations', ['getIntegration', 'refreshIntegration']),

    async load (done) {
      const { params } = this
      try {
        await this.getScreens({ params })

        done()
      } catch {
        done(true)
      }
    },

    async refreshData () {
      const { params } = this
      await Promise.all([
        this.getScreens({ params, fresh: true }),
        this.getIntegration(this.integration.id)
      ])
    },

    async handleRemoveScreen (screen) {
      await this.deleteScreen(screen.id)
      await this.refreshData()
    },

    async handleAddScreen (screen) {
      await this.storeScreen({ screen_id: screen.id })
      await this.refreshData()
    }
  }
}

</script>
